import { Typography } from "antd"; 
// import dayjs from 'dayjs';
/** get items column */
const optionTypeSup = [    
    { value: "IG", label: "Ingredients" },
    { value: "RM", label: "Raw Material" },
    { value: "PK", label: "Packaging" },
    { value: "API", label: "Oversea" },
];

export const columns = ({handleChoose})=>{
    const Link = Typography.Link;
    return [
      {
        title: "Supplier Code",
        key: "supcode",
        dataIndex: "supcode", 
        width: 94,
        render: (v, record) => <Link className="text-select hover:underline underline-offset-1" onClick={()=>handleChoose(record)}>{v}</Link>
      },
      {
        title: "Supplier Name",
        dataIndex: "supname",
        key: "supname", 
        render: (v, record) => <Link className="text-select hover:underline underline-offset-1" onClick={()=>handleChoose(record)}>{v}</Link>
      },
      {
        title: "PO ค้างรับสินค้า",
        dataIndex: "pooutstanding",
        key: "pooutstanding", 
        width: 120,
      },
      {
        title: "ประเภทผู้ขาย",
        dataIndex: "suptype",
        key: "suptype",
        width: 184, 
        render: (v, record) => {
          const found = optionTypeSup.find(opt => opt.value === v);
          return (
            <Link
              className="text-select hover:underline underline-offset-1"
              onClick={() => handleChoose(record)}
            >
              {found ? found.label : v}
            </Link>
          );
        }
      },
    ]
  };